import React, { useState, useEffect } from 'react';
import './AparienciaData.css';
import baseURL from '../../url';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import imageIcon from '../../../images/imageIcon.png';
import Swal from 'sweetalert2';

const SECCIONES = [
    { key: 'banner_full', label: 'Banner Ancho Completo', desc: 'Se muestra en la parte superior de la tienda', icono: '🖼️' },
    { key: 'banner_tres_col', label: 'Banners 3 Columnas', desc: 'Tres banners en fila debajo del banner principal', icono: '▦' },
    { key: 'banner_marcas', label: 'Banner de Marcas', desc: 'Aparece entre la oferta del día y del mes', icono: '🏷️' },
];

export default function AparienciaData() {
    const [seccionActiva, setSeccionActiva] = useState('banner_full');
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editando, setEditando] = useState(null);

    // Form
    const [titulo, setTitulo] = useState('');
    const [subtitulo, setSubtitulo] = useState('');
    const [urlDestino, setUrlDestino] = useState('');
    const [imgPreview, setImgPreview] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [estado, setEstado] = useState('activo');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => { cargar(); }, [seccionActiva]);

    const cargar = () => {
        setLoading(true);
        fetch(`${baseURL}/aparienciaGet.php?seccion=${seccionActiva}`)
            .then(r => r.json())
            .then(d => setBanners(d.banners || []))
            .catch(() => setBanners([]))
            .finally(() => setLoading(false));
    };

    const abrirNuevo = () => {
        setEditando(null); setTitulo(''); setSubtitulo(''); setUrlDestino('');
        setImgPreview(null); setImgFile(null); setEstado('activo');
        setModalOpen(true);
    };

    const abrirEditar = (b) => {
        setEditando(b); setTitulo(b.titulo || ''); setSubtitulo(b.subtitulo || '');
        setUrlDestino(b.urlDestino || ''); setImgPreview(b.imagen || null);
        setImgFile(null); setEstado(b.estado || 'activo');
        setModalOpen(true);
    };

    const handleImg = (e) => {
        const f = e.target.files[0];
        if (f) { setImgFile(f); setImgPreview(URL.createObjectURL(f)); }
    };

    const guardar = async () => {
        if (!imgFile && !editando?.imagen) { toast.error('Sube una imagen'); return; }
        setGuardando(true);
        const fd = new FormData();
        fd.append('seccion', seccionActiva);
        fd.append('titulo', titulo);
        fd.append('subtitulo', subtitulo);
        fd.append('urlDestino', urlDestino);
        fd.append('estado', estado);
        if (imgFile) fd.append('imagen', imgFile);
        if (editando) fd.append('idBannerApariencia', editando.idBannerApariencia);
        const url = editando ? `${baseURL}/aparienciaUpdate.php` : `${baseURL}/aparienciaPost.php`;
        try {
            const res = await fetch(url, { method: 'POST', body: fd });
            const d = await res.json();
            if (d.mensaje) { toast.success(editando ? 'Actualizado ✅' : 'Creado ✅'); setModalOpen(false); cargar(); }
            else toast.error(d.error || 'Error');
        } catch { toast.error('Error de conexión'); }
        setGuardando(false);
    };

    const eliminar = (b) => {
        Swal.fire({ title: '¿Eliminar banner?', icon: 'warning', showCancelButton: true, confirmButtonColor: '#e53935', confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' })
            .then(async r => {
                if (!r.isConfirmed) return;
                const fd = new FormData();
                fd.append('idBannerApariencia', b.idBannerApariencia);
                const res = await fetch(`${baseURL}/aparienciaDelete.php`, { method: 'POST', body: fd });
                const d = await res.json();
                if (d.mensaje) { toast.success('Eliminado'); cargar(); }
                else toast.error(d.error || 'Error');
            });
    };

    const toggleEstado = async (b) => {
        const nuevoEstado = b.estado === 'activo' ? 'inactivo' : 'activo';
        const fd = new FormData();
        fd.append('idBannerApariencia', b.idBannerApariencia);
        fd.append('estado', nuevoEstado);
        const res = await fetch(`${baseURL}/aparienciaUpdate.php`, { method: 'POST', body: fd });
        const d = await res.json();
        if (d.mensaje) { cargar(); toast.success(`Banner ${nuevoEstado}`); }
    };

    const secInfo = SECCIONES.find(s => s.key === seccionActiva);
    const limiteAlcanzado = seccionActiva === 'banner_tres_col' && banners.length >= 3;

    return (
        <div className="aparienciaData">
            <ToastContainer />
            <div className="aparienciaHeader">
                <div>
                    <h2>🎨 Apariencia</h2>
                    <p>Configura los banners y elementos visuales de tu tienda.</p>
                </div>
            </div>

            {/* Tabs de sección */}
            <div className="aparienciaTabs">
                {SECCIONES.map(s => (
                    <button key={s.key} className={`aparienciaTab ${seccionActiva === s.key ? 'active' : ''}`} onClick={() => setSeccionActiva(s.key)}>
                        <span>{s.icono}</span>
                        <span>{s.label}</span>
                    </button>
                ))}
            </div>

            {/* Info de la sección activa */}
            <div className="aparienciaSeccionInfo">
                <div className="aparienciaSeccionDesc">
                    <strong>{secInfo?.icono} {secInfo?.label}</strong>
                    <span>{secInfo?.desc}</span>
                    {seccionActiva === 'banner_tres_col' && <span className="limitNote">Máximo 3 banners ({banners.length}/3)</span>}
                </div>
                {!limiteAlcanzado && (
                    <button className="btnNuevoBanner" onClick={abrirNuevo}>+ Agregar banner</button>
                )}
            </div>

            {loading ? <div className="aparienciaLoading">Cargando...</div> :
                banners.length === 0 ? (
                    <div className="aparienciaVacio">
                        <span>{secInfo?.icono}</span>
                        <p>No hay banners en esta sección. ¡Agrega el primero!</p>
                    </div>
                ) : (
                    <div className={`bannersGrid ${seccionActiva === 'banner_full' ? 'fullWidth' : ''}`}>
                        {banners.map(b => (
                            <div key={b.idBannerApariencia} className={`bannerApCard ${b.estado !== 'activo' ? 'inactivo' : ''}`}>
                                <div className="bannerApImg">
                                    {b.imagen
                                        ? <img src={b.imagen} alt={b.titulo} />
                                        : <div className="bannerApImgPh">Sin imagen</div>
                                    }
                                    <span className={`bannerApEstado ${b.estado}`}>{b.estado === 'activo' ? '🟢' : '🔴'}</span>
                                </div>
                                <div className="bannerApBody">
                                    {b.titulo && <strong>{b.titulo}</strong>}
                                    {b.subtitulo && <span>{b.subtitulo}</span>}
                                    {b.urlDestino && <code>{b.urlDestino}</code>}
                                </div>
                                <div className="bannerApAcciones">
                                    <button className={`btnToggleBanner ${b.estado === 'activo' ? 'deshabilitar' : 'habilitar'}`} onClick={() => toggleEstado(b)}>
                                        {b.estado === 'activo' ? '⛔ Desactivar' : '✅ Activar'}
                                    </button>
                                    <button className="btnEditBanner" onClick={() => abrirEditar(b)}>✏️ Editar</button>
                                    <button className="btnDelBanner" onClick={() => eliminar(b)}>🗑️</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            }

            {/* Modal */}
            {modalOpen && (
                <div className="aparienciaOverlay" onClick={() => setModalOpen(false)}>
                    <div className="aparienciaModal" onClick={e => e.stopPropagation()}>
                        <div className="aparienciaModalHeader">
                            <h3>{editando ? 'Editar banner' : 'Nuevo banner'}</h3>
                            <button onClick={() => setModalOpen(false)}>✕</button>
                        </div>
                        <div className="aparienciaModalBody">
                            <label>Imagen *</label>
                            <label htmlFor="bannerApImg" className="apImgUpload">
                                {imgPreview
                                    ? <img src={imgPreview} alt="" className="apImgPreview" />
                                    : <><img src={imageIcon} alt="" style={{width:36,opacity:.4}} /><span>Subir imagen</span></>
                                }
                            </label>
                            <input id="bannerApImg" type="file" accept="image/*" onChange={handleImg} style={{ display: 'none' }} />
                            {imgPreview && <button className="btnQuitarApImg" onClick={() => { setImgPreview(null); setImgFile(null); }}>🗑️ Quitar imagen</button>}

                            <label>Título (opcional)</label>
                            <input type="text" value={titulo} onChange={e => setTitulo(e.target.value)} placeholder="Ej: Gran Oferta de Verano" />

                            <label>Subtítulo (opcional)</label>
                            <input type="text" value={subtitulo} onChange={e => setSubtitulo(e.target.value)} placeholder="Ej: Hasta 50% de descuento" />

                            <label>URL de destino (opcional)</label>
                            <input type="text" value={urlDestino} onChange={e => setUrlDestino(e.target.value)} placeholder="Ej: /productos?categoria=verano" />

                            <label>Estado</label>
                            <div className="apEstadoToggle">
                                <button className={estado === 'activo' ? 'active' : ''} onClick={() => setEstado('activo')}>🟢 Activo</button>
                                <button className={estado === 'inactivo' ? 'active' : ''} onClick={() => setEstado('inactivo')}>🔴 Inactivo</button>
                            </div>
                        </div>
                        <div className="aparienciaModalFooter">
                            <button className="btnCancelar" onClick={() => setModalOpen(false)}>Cancelar</button>
                            <button className="btnGuardar" onClick={guardar} disabled={guardando}>
                                {guardando ? 'Guardando...' : editando ? 'Actualizar' : 'Crear banner'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
